
<script setup>

  import { ref } from 'vue';

  import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';

  import { ChevronUpIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import FitContainer from '../components/fit-container.vue';

  import SimpleDialog from '../dialogs/simple.vue';

  import backgroundPath from '../images/summit-background.jpg';

  import partials from '../partials/activity-3-part-1-*.vue';

  import peoplePaths from '../images/activity-3-part-1-*.png';

  const people = [ {

    id: 'shirley',
    
    top: 52, left: 37,

    button: { top: 41.5, left: 35 },
    
    title: 'Shirley Ann Tutt McCoy'

  }, {

    id: 'elaine',
    
    top: 52, left: 21,

    button: { top: 32, left: 16 },
    
    title: 'Elaine Taylor Blakey'
    
  }, {

    id: 'audrey',
    
    top: 72, left: 33,

    button: { top: 75, left: 33 },
    
    title: 'Audrey Tutt Smith'

  }, {

    id: 'beulah',
    
    top: 50, left: 64,

    button: { top: 40, left: 63 },
    
    title: 'Beulah Billings'

  }, {

    id: 'maxine',
    
    top: 54, left: 50,

    button: { top: 58, left: 50.5 },
    
    title: 'Maxine Tutt'

  }, {

    id: 'columbus',
    
    top: 52, left: 75,

    button: { top: 36, left: 83 },
    
    title: 'Columbus Tutt'

  } ].map( obj => ( { ...obj, dialog: ref( null ), path: peoplePaths[ obj.id ] } ) );

  function setDialog( id, el ) {

    const person = people.find( person => person.id === id );

    person.dialog.value = el;

  }

</script>

<template>

  <article>

    <div class="grid bg-fixed bg-cover bg-center" :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="md:hidden row-start-1 col-start-1 relative flex items-center justify-center min-h-view px-6 py-12">

        <div class="w-full max-w-xl">

          <h3 class="text-5xl font-heading uppercase">
            
            Click or tap a name to learn more
          
          </h3>

          <div class="mt-6 divide-y divide-neutral-400">

            <div v-for="{ id, title, path } in people">

              <Disclosure v-slot="{ open }">

                <DisclosureButton class="group flex w-full h-40 items-center">

                  <div class="flex items-center justify-center min-w-[96px] max-w-[96px]">

                    <img class="h-24" :src="path" alt="" draggable="false" />

                  </div>

                  <div class="text-xl text-left px-8 mr-auto group-hover:underline group-focus-visible:underline">
                    
                    {{ title }}
                  
                  </div>

                  <ChevronUpIcon :class="[ 'h-6 w-6', { 'rotate-180 transform': ! open } ]" />

                </DisclosureButton>

                <DisclosurePanel class="pb-9">

                  <component :is="partials[ id ].default" />

                </DisclosurePanel>

              </Disclosure>

            </div>

          </div>

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 mt-6 font-bold text-white bg-green-700 transition-colors pointer-events-auto
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/3/part/2">

            <span>Continue</span>

            <ArrowRightCircleIcon class="w-8" />

          </RouterLink>

        </div>

      </div>

      <div class="hidden md:flex row-start-1 col-start-1 justify-center items-start w-full h-view px-5 py-16">

        <h3 class="text-5xl font-heading uppercase">
          
          Click or touch a name to learn more
        
        </h3>

      </div>

      <FitContainer class="hidden md:block row-start-1 col-start-1 w-full h-view" :width="1100" :height="900" fit="contain" v-slot="{ scale }">

        <template v-for="{ top, left, button, title, dialog, path } in people">

          <img :src="path" class="absolute pointer-events-none"
          
            :style="{ top: `${ top }%`, left: `${ left }%`, transform: `translate( -50%, -50% ) scale( ${ scale } )` }"  alt="" />

          <button type="button" @click="dialog.value.open()"
          
            class="absolute px-4 py-3 text-sm font-semibold bg-amber-300 -translate-x-1/2 -translate-y-1/2 z-10"
            
            :style="{ top: `${ button.top }%`, left: `${ button.left }%` }">

            {{ title }}

          </button>

        </template>

      </FitContainer>

      <div class="hidden md:flex relative row-start-1 col-start-1 justify-center items-end w-full h-view px-5 py-16 pointer-events-none">

        <RouterLink
        
          class="flex items-center gap-4 px-6 py-4 font-bold text-white bg-green-700 transition-colors pointer-events-auto
          
            hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
        
          to="/activity/3/part/2">

          <span>Continue</span>

          <ArrowRightCircleIcon class="w-8" />

        </RouterLink>

      </div>

    </div>

    <SimpleDialog v-for="{ id, title } in people" :ref="el => setDialog( id, el )" :title="title" class="max-w-xl">
    
      <component :is="partials[ id ].default" />

    </SimpleDialog>

  </article>

</template>
